import http from '@/libs/AxiosPlugin'

const maintain = {
  list () {
    return http.get('/maintain/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, deviceNo: 'o-001', operator: 'DaviaLi', startTime: '2017-09-01 10:00', endTime: '2017-10-01 11:00', remark: ''},
    //     {id: 2, deviceNo: 'o-001', operator: 'DaviaLi', startTime: '2017-09-01 13:32', endTime: '2017-10-01 14:53', remark: ''}
    //   ]
    //   resolve(data)
    // })
  },

  get (id) {
    return http.post('/maintain/get', {id})
  },

  save (m) {
    return http.post('/maintain/save', m)
  }
}

export default maintain



// WEBPACK FOOTER //
// ./src/api/maintain.js